import { Component, OnInit } from '@angular/core';
import { BarometricToolService } from 'src/app/services/barometric-tool.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { PointsService } from 'src/app/services/points.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-barometric-calculation',
  templateUrl: './barometric-calculation.component.html',
  styleUrls: ['./barometric-calculation.component.scss'],
  standalone: false
})
export class BarometricCalculationComponent implements OnInit {

  //Standard Temperature: 15 degrees C or 59 degrees F
	STANDARD_TEMPERATURE : number = 15; //[C]

	//Standard Pressure: 1013 hPa (or mbar) or 29.92 inHg
	STANDARD_PRESSURE : number  = 1013; // [hPa]

	//Correction value: 27ft per hPa deviation from standard pressure.
	//Lower pressures means lower altitudes.
	PRESSURE_CORRECTION_VALUE : number = 27; // [ft]

  TEMPERATURE_MAX : number = 80; // Celcius
	TEMPERATURE_MIN : number = -80; // Celcius

	PRESSURE_MAX = 1200; // hPa
	PRESSURE_MIN = 800; // hPa

  MIN_ALT_VALUE : number = -999999999; // MIN_ALT_VALUE

  altitudeMeters : number = 0; // default static value
  altitudeFeets : number = 0; // default static value
  temperatureD : number = 15; // default static value
  temperatureF : number;
  presureHpa : number = 1013 // default static value
  presureinHg : number;

  correctedTemperatureAltitudeFeets : number = 0; // default static value
  correctedTemperatureAltitudeMeters : number = 0; // default static value

  correctedPressureAltitudeFeets : number = 0; // default static value
  correctedPressureAltitudeMeters : number = 0; // default static value

  temperaturePressureCorrectionFeets : number = 0; // default static value
  temperaturePressureCorrectionMeters : number = 0; // default static value

  form : FormGroup;

  constructor(
    public barometricToolController : BarometricToolService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,
    public pointsController : PointsService
  ) {
    this.temperatureF = this.pointsController.convertCelciusToFahrenheit(this.temperatureD);
    this.presureinHg = this.pointsController.convertHpaToInHg(this.presureHpa);
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      altitudeFeets: new FormControl(this.altitudeFeets,[Validators.min(this.MIN_ALT_VALUE)]),
      altitudeMeters: new FormControl(this.altitudeMeters,[Validators.min(this.MIN_ALT_VALUE)]),
      temperatureD: new FormControl(this.temperatureD,[Validators.min(this.TEMPERATURE_MIN),Validators.max(this.TEMPERATURE_MAX)]),
      temperatureF: new FormControl(this.temperatureF),
      pressureHpa: new FormControl(this.presureHpa,[Validators.min(this.PRESSURE_MIN),Validators.max(this.PRESSURE_MAX)]),
      pressureInHg: new FormControl(this.presureinHg),
      correctedTemperatureAltitudeFeets: new FormControl({value:this.correctedTemperatureAltitudeFeets, disabled:true}),
      correctedTemperatureAltitudeMeters: new FormControl({value:this.correctedTemperatureAltitudeMeters, disabled:true}),
      correctedPressureAltitudeFeets: new FormControl({value:this.correctedPressureAltitudeFeets, disabled:true}),
      correctedPressureAltitudeMeters: new FormControl({value:this.correctedPressureAltitudeMeters, disabled:true}),
      temperaturePressureCorrectionFeets: new FormControl({value:this.temperaturePressureCorrectionFeets, disabled:true}),
      temperaturePressureCorrectionMeters: new FormControl({value:this.temperaturePressureCorrectionMeters, disabled:true})
    })
  }

  showTempAltitudeCorrection(): void{
		let altitudeCorrection : number;
		let correctedAltitude : number;
		let tempPlusPressCorrectedAltitude : number;
		let temperature = this.temperatureD;
		let altitude = this.altitudeFeets;
		altitudeCorrection = (this.STANDARD_TEMPERATURE - temperature) / 10 * 0.04 * altitude;

		correctedAltitude = altitude - altitudeCorrection;

		this.correctedTemperatureAltitudeFeets = correctedAltitude;
		this.correctedTemperatureAltitudeMeters =  this.pointsController.convertToMeters(correctedAltitude);

		tempPlusPressCorrectedAltitude = this.correctedPressureAltitudeFeets - altitudeCorrection;
		this.temperaturePressureCorrectionFeets = tempPlusPressCorrectedAltitude;
		this.temperaturePressureCorrectionMeters = this.pointsController.convertToMeters(tempPlusPressCorrectedAltitude);
	}

	showPressureAltitudeCorrection() : void{
		let altitudeCorrection : number;
		let correctedAltitude : number;
		let tempPlusPressCorrectedAltitude : number;
		let pressure = this.presureHpa;
		let altitude = this.altitudeFeets;
		altitudeCorrection = (this.STANDARD_PRESSURE - pressure) * this.PRESSURE_CORRECTION_VALUE;

		correctedAltitude = altitude - altitudeCorrection;

		this.correctedPressureAltitudeFeets = correctedAltitude;
    this.correctedPressureAltitudeMeters = this.pointsController.convertToMeters(correctedAltitude);

		tempPlusPressCorrectedAltitude = this.correctedTemperatureAltitudeFeets - altitudeCorrection;
		this.temperaturePressureCorrectionFeets = tempPlusPressCorrectedAltitude;
		this.temperaturePressureCorrectionMeters = this.pointsController.convertToMeters(tempPlusPressCorrectedAltitude);
	}

  cancelWindow():void{
    this.barometricToolController.active = !this.barometricToolController.active;
    this.toolsService.navigationOnTop = false;
  }

  updateAltitudeMeters(value : any){
    this.altitudeMeters = this.pointsController.convertToMeters(value);
    this.showTempAltitudeCorrection();
    this.showPressureAltitudeCorrection();
  }

  updateAltitudeFeets(value : any){
    this.altitudeFeets = this.pointsController.convertToFeet(value);
    this.showTempAltitudeCorrection();
    this.showPressureAltitudeCorrection();
  }

  updateTemperatureDegrees(value : any){
    this.temperatureF = this.pointsController.convertCelciusToFahrenheit(value);
    this.showTempAltitudeCorrection();
  }

  updateTemperatureFahrenheit(value : any){
    this.temperatureD = this.pointsController.convertFahrenheitToCelcius(value);
    this.showTempAltitudeCorrection();
  }

  updatePresureHpa(value : any){
    this.presureinHg = this.pointsController.convertHpaToInHg(value);
    this.showPressureAltitudeCorrection();
  }

  updatePresureHg(value : any){
    this.presureHpa = this.pointsController.convertInHgToHpa(value);
    this.showPressureAltitudeCorrection();
  }

}
